import { doc, getDoc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './config';

export const createUserDocument = async (user, extraData = {}) => {
     if (!user?.uid) return;

     const userRef = doc(db, 'users', user.uid);
     const userSnap = await getDoc(userRef);

     const baseUserData = {
          uid: user.uid,
          name: user.displayName || extraData.name || '',
          email: user.email || '',
          photoURL: user.photoURL || '',
          provider: extraData.provider || 'email',
          role: 'user',
          isProfileComplete: false,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
     };

     if (!userSnap.exists()) {
          await setDoc(userRef, baseUserData);
     } else {
          await updateDoc(userRef, {
               name: user.displayName || extraData.name || '',
               email: user.email || '',
               photoURL: user.photoURL || '',
               provider: extraData.provider || 'email',
               updatedAt: serverTimestamp(),
          });
     }
};